import { render, staticRenderFns } from "./subordersInfo.vue?vue&type=template&id=7f106978&"
import script from "./subordersInfo.vue?vue&type=script&lang=js&"
export * from "./subordersInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports